"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToPrevious = exports.convertFromPrevious = void 0;
const convertFromPrevious = (s, v) => {
    const oldSettings = s;
    const settings = {
        settings_version: '6.0',
        ar: oldSettings.ar,
        build_date: oldSettings.build_date,
        build_version: oldSettings.build_version,
        camera: oldSettings.camera,
        general: {
            transformation: oldSettings.general.transformation,
            blurWhenBusy: oldSettings.general.blurWhenBusy,
            commitSettings: oldSettings.general.commitSettings,
            commitParameters: oldSettings.general.commitParameters,
            pointSize: oldSettings.general.pointSize,
            showMessages: oldSettings.general.showMessages
        },
        light: oldSettings.light,
        session: oldSettings.session,
        environment: oldSettings.environment,
        environmentGeometry: oldSettings.environmentGeometry,
        rendering: oldSettings.rendering,
        postprocessing: oldSettings.postprocessing,
        material: {
            defaultMaterialColor: oldSettings.general.defaultMaterialColor,
            materialOverrideType: undefined
        }
    };
    /**
     * SETTINGS OBJECTS THAT DID CHANGE
     */
    return settings;
};
exports.convertFromPrevious = convertFromPrevious;
const convertToPrevious = (s, v) => {
    const newSettings = s;
    const settings = {
        settings_version: '5.0',
        ar: newSettings.ar,
        build_date: newSettings.build_date,
        build_version: newSettings.build_version,
        camera: newSettings.camera,
        general: {
            transformation: newSettings.general.transformation,
            blurWhenBusy: newSettings.general.blurWhenBusy,
            commitSettings: newSettings.general.commitSettings,
            commitParameters: newSettings.general.commitParameters,
            pointSize: newSettings.general.pointSize,
            showMessages: newSettings.general.showMessages,
            defaultMaterialColor: newSettings.material ? newSettings.material.defaultMaterialColor : newSettings.general.defaultMaterialColor
        },
        light: newSettings.light,
        session: newSettings.session,
        environment: newSettings.environment,
        environmentGeometry: {
            gridColor: newSettings.environmentGeometry.gridColor,
            gridVisibility: newSettings.environmentGeometry.gridVisibility,
            groundPlaneColor: newSettings.environmentGeometry.groundPlaneColor,
            groundPlaneVisibility: newSettings.environmentGeometry.groundPlaneVisibility,
            groundPlaneShadowColor: newSettings.environmentGeometry.groundPlaneShadowColor,
            groundPlaneShadowVisibility: newSettings.environmentGeometry.groundPlaneShadowVisibility
        },
        rendering: newSettings.rendering,
        postprocessing: newSettings.postprocessing
    };
    /**
     * SETTINGS OBJECTS THAT DID CHANGE
     */
    return settings;
};
exports.convertToPrevious = convertToPrevious;
//# sourceMappingURL=Converter.js.map